import React, { Component } from 'react'
import { ConnectedRouter } from 'react-router-redux'
import { Switch, Route, Redirect } from 'react-router'
import { HashRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { AlertHandler } from 'components/core'
import { Header, Sidebar } from 'projects/flow-gui-access/components/core'
import { Installation, loadConfig } from 'config'
import history from 'store/history'
import Routes from 'routes'
import { FourOhFour, Unauthorized } from 'views/core'
import { Login } from 'projects/flow-gui-access/views/middlewares/core'
import { LoadingIndicator, NoContentBox } from 'components/basic'

class Flow extends Component {
  constructor (props) {
    super(props)
    this.state = {
      error: false,
      loading: true,
      connected: true
    }
    this.resizedDimensions = this.resizedDimensions.bind(this)
    window.addEventListener('resize', this.resizedDimensions)
  }
  resizedDimensions () {
    if (window.innerWidth <= Installation.collapsegui) {
      this.props.dispatch({type: 'SET_SIDEBAR_STATE', payload: false})
    }
    if (window.innerWidth <= Installation.collapsegui) {
      return this.props.dispatch({type: 'SET_MOBILE_STATE', payload: true})
    }
    if (this.props.siteReducer.isMobile) this.props.dispatch({type: 'SET_MOBILE_STATE', payload: false})
  }
  async componentWillMount () {
  }
  async componentDidMount () {
    await loadConfig().then(() => {
      this.setState({ loading: false })
    }).catch(() => {
      this.setState({ error: true, loading: false })
    })
    document.title = Installation.title
    this.resizedDimensions()
  }
  componentWillUnmount () {
    window.removeEventListener('resize', this.resizedDimensions)
  }
  componentDidUpdate () {
    document.title = Installation.systemName + ' - ' + this.props.siteReducer.pageTitle
  }
  render () {
    if (this.state.loading) {
      return <LoadingIndicator />
    }
    if (this.state.error) {
      return (
        <div className='content-wrapper flexbox-absolute-center'>
          <NoContentBox icon='exclamation-circle' text='Error Loading Resources' />
        </div>
      )
    }
    if (!this.props.siteReducer.auth.username) {
      return <Login />
    }
    return (
      <div className={'site-wrapper ' + (this.props.siteReducer.sidebar ? 'sidebar-active' : 'sidebar-hidden')}>
        <Header />
        <div className='wrapper'>
          <Sidebar />
          <ConnectedRouter history={history}>
            <HashRouter basename='/'>
              <Switch>
                <Route exact path='/' render={() => {
                  return <Redirect to='/access' />
                }} />
                <Route exact path='/flow/dashboard' render={() => {
                  return <Redirect to='/access' />
                }} />
                {Routes.map(route => {
                  if (route.admin) {
                    if (this.props.siteReducer.user.admin) {
                      return (<Route key={route.path} exact={route.exact} path={route.path} component={route.component} />)
                    } else {
                      return (<Route key={route.path} exact={route.exact} path={route.path} component={Unauthorized} />)
                    }
                  }
                  return (<Route key={route.path} exact={route.exact} path={route.path} component={route.component} />)
                })}
                <Route component={FourOhFour} />
              </Switch>
            </HashRouter>
          </ConnectedRouter>
        </div>
        <AlertHandler />
      </div>
    )
  }
}
// eslint-disable-next-line
Flow = connect(state => state)(Flow)
export default Flow



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/entry.js